import React, { useEffect, useRef, useState } from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  name: string;
  renderPlaceholder?: () => JSX.Element;
  renderError?: () => JSX.Element;
}

const DynamicSvgIcon = ({ name, renderPlaceholder, renderError, ...rest }: Props) => {
  const iconsPath = "icons";

  // icon ref
  const iconRef = useRef<React.FC<React.SVGProps<SVGSVGElement>>>();
  
  // state
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  // side-effects
  useEffect(() => {
    setLoading(true);
    importIcon();
  }, [name]);

  // helpers
  const importIcon = async (): Promise<void> => {
    try {
      iconRef.current = (await import(`!!@svgr/webpack?-svgo,+titleProp,+ref!configuration/${process.env.REACT_APP_CLIENT}/${iconsPath}/${name}.svg`)).default;
    } catch (err) {
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  // render
  if (loading) {
    return renderPlaceholder ? renderPlaceholder() : <></>;
  } else if (isError) {
    return renderError ? renderError() : <></>;
  } else if (iconRef.current) {
    const { current: ImportedIcon } = iconRef;
    return <ImportedIcon {...rest} />
  } else {
    return null;
  }
}

export default DynamicSvgIcon;
